import { gql } from '@apollo/client';

import { RESUME_FIELDS } from './fields';

// TODO: Temporary mock this query, waiting for realize

// export const GET_DRAFT_RESUME = gql`
//   ${RESUME_FIELDS}
//   query GetDraftResume {
//     draftResume {
//       ...resumeFields
//     }
//   }
// `;

export const GET_RESUME_BY_ID = gql`
  ${RESUME_FIELDS}
  query Resume($id: ID!) {
    resume(id: $id) {
      ...resumeFields
    }
  }
`;
